<template>
  <v-dialog v-model="showOnlyForEmployeesDialog" max-width="40%" :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title class="primary white--text">
        <h3 class="headline mb-0">{{ $t('texts.onlyForEmployees') }}</h3>
        <v-spacer/>
        <v-btn text small fab @click="showOnlyForEmployeesDialog = false">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container class="pa-0" grid-list-xl>
          <v-row>
            <v-col :cols="12">
              {{ $t('texts.onlyForEmployeesText') }}
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-divider/>
      <v-card-actions class="pr-3">
        <v-spacer/>
        <v-btn color="primary" class="white--text" @click="showOnlyForEmployeesDialog = false">
          {{ $t('texts.understood') }}
          <v-icon right class="white--text">check_circle</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'OnlyForEmployeesDialog',
  data() {
    return {
      showOnlyForEmployeesDialog: false,
    };
  },
  mounted() {
    this.$eventBus.$on('show-only-for-employee-dialog', () => {
      this.showOnlyForEmployeesDialog = true;
    });
  },
};
</script>
